import { OpenQuestionDefinitionDto, UserQuizQuestionAnswerDto } from '@/api/generated';
import { DomPurifyConfig } from '@/config/DomPurify.config.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { validateStringArea } from '@/utils/validateStringArea.ts';
import DOMPurify from 'dompurify';
import parseHtml from 'html-react-parser';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';

interface OpenQuestionProps {
  disabled: boolean;
  onAnswerSelected: (questionDefinition: UserQuizQuestionAnswerDto) => void;
  questionDefinition: {
    discriminatorType: 'OPEN';
  } & OpenQuestionDefinitionDto;
}

const OpenQuestionForm: React.FC<OpenQuestionProps> = ({
  disabled,
  onAnswerSelected,
  questionDefinition,
}) => {
  const { t } = useTranslationWithPrefix('views.process.quizQuestions');

  const { question } = questionDefinition;
  const [formData, setFormData] = useState<string>('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onAnswerSelected({
      answer: formData,
      discriminatorType: questionDefinition.discriminatorType,
    });
  };

  const handleBlockPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
  };

  return (
    <Form className="flex flex-column gap-l" onSubmit={handleSubmit}>
      <p className="lead fw-bold">{parseHtml(DOMPurify.sanitize(question, DomPurifyConfig))}</p>
      <Form.Group>
        <Form.Control
          as="textarea"
          className="lead"
          disabled={disabled}
          maxLength={500}
          minLength={3}
          name={question}
          onChange={handleChange}
          onPaste={handleBlockPaste}
          rows={6}
          value={formData}
        />
      </Form.Group>
      <Button
        className="px-sm-5 align-self-sm-start"
        disabled={disabled || validateStringArea(3, formData)}
        type="submit"
      >
        {t('buttons.next')}
      </Button>
    </Form>
  );
};

export default OpenQuestionForm;
